import React, { useState, useEffect } from "react";
import { $host } from "../../../../../http";
import "../UserModal.css";

const AssignCourse = ({ user, onClose }) => {
    const [courses, setCourses] = useState([]);
    const [isSubscriptionModalOpen, setSubscriptionModalOpen] = useState(false);
    const [selectedSubscription, setSelectedSubscription] = useState(null);
    const [subscriptionNotFound, setSubscriptionNotFound] = useState(false);
    const [subscriptions, setSubscriptions] = useState([]);
    const [selectedCourseTitle, setSelectedCourseTitle] = useState("");
    const [endDate, setEndDate] = useState("");
    const [courseOptions, setCourseOptions] = useState([]); // Глобальный список всех опций
    const [selectedOptions, setSelectedOptions] = useState([]); // Опции текущей подписки
    const [isEditingDate, setIsEditingDate] = useState(false);
    const [isEditingOptions, setIsEditingOptions] = useState(false);

    useEffect(() => {
        fetchSubscriptionsAndCourses();
        fetchCourseOptions();
    }, [user]);

    const fetchSubscriptionsAndCourses = async () => {
        if (!user.subscriptions || user.subscriptions.length === 0) {
            alert("У пользователя нет активных подписок.");
            onClose();
            return;
        }

        try {
            const subscriptionsData = await Promise.all(
                user.subscriptions.map(async (subscriptionId) => {
                    try {
                        const { data } = await $host.get(`/api/admin/subscriptions/${subscriptionId}`);
                        return { ...data, id: subscriptionId };
                    } catch (error) {
                        console.error(`Ошибка загрузки подписки ${subscriptionId}:`, error);
                        return null;
                    }
                })
            );

            const validSubscriptions = subscriptionsData.filter(Boolean);
            if (validSubscriptions.length === 0) {
                setSubscriptionNotFound(true);
                return;
            }

            setSubscriptions(validSubscriptions);

            const courseIds = validSubscriptions.map((sub) => sub.course_id);
            const coursesData = await Promise.all(
                courseIds.map(async (courseId) => {
                    try {
                        const { data } = await $host.get(`/api/public/courses/${courseId}`);
                        return data;
                    } catch (error) {
                        console.error(`Ошибка загрузки курса ${courseId}:`, error);
                        return null;
                    }
                })
            );

            setCourses(coursesData.filter(Boolean));
        } catch (error) {
            console.error("Ошибка при загрузке подписок и курсов:", error);
            alert("Не удалось загрузить данные.");
        }
    };

    const fetchCourseOptions = async () => {
        try {
            const { data } = await $host.get("/api/public/course-options");
            setCourseOptions(data);
        } catch (error) {
            console.error("Ошибка загрузки опций курса:", error);
        }
    };

    const fetchSubscriptionDetails = async (subscriptionId, courseTitle) => {
        try {
            const { data } = await $host.get(`/api/admin/subscriptions/${subscriptionId}`);
            setSelectedSubscription(data);
            setSelectedCourseTitle(courseTitle);
            setEndDate(data.end_date);
            setSelectedOptions(data.options || []);
            setIsEditingDate(false);
            setIsEditingOptions(false);
            setSubscriptionModalOpen(true);
        } catch (error) {
            console.error("Ошибка при загрузке подписки:", error);
            setSubscriptionNotFound(true);
        }
    };

    const handleRemoveSubscription = async () => {
        if (!selectedSubscription) return;
        try {
            await $host.post("/api/admin/courses/remove", {
                student_id: user.id,  // ✅ ID студента
                subscription_id: selectedSubscription.id, // ✅ Исправлено: теперь передаём `id`, как ожидает бэк
            });
            console.log("request:", user.id, selectedSubscription.id);
            alert("Подписка успешно удалена!");
            setSubscriptionModalOpen(false);
            fetchSubscriptionsAndCourses();
        } catch (error) {
            console.error("Ошибка удаления подписки:", error);
            alert("Не удалось удалить подписку.");
        }
    };


    const handleSaveSubscription = async () => {
        if (!selectedSubscription) return;
        try {
            await $host.put("/api/admin/subscriptions/update", {
                subscription_id: selectedSubscription.id,
                end_date: new Date(endDate).toISOString(),
                add_option_ids: selectedOptions,
            });
            alert("Подписка успешно обновлена!");
            setSubscriptionModalOpen(false);
            fetchSubscriptionsAndCourses();
        } catch (error) {
            console.error("Ошибка обновления подписки:", error);
            alert("Не удалось обновить подписку.");
        }
    };

    const handleOptionToggle = (event) => {
        const selectedValues = Array.from(event.target.selectedOptions, option => option.value);
        setSelectedOptions(selectedValues);
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="modal-close" onClick={onClose}>✖</button>
                <h2 className="modal-header ">Купленные курсы</h2>
                {subscriptionNotFound ? (
                    <div>
                        <p>Подписка не найдена. Возможно, она была удалена.</p>
                        <button className="remove-btn" onClick={handleRemoveSubscription}>
                            Удалить подписку
                        </button>
                    </div>
                ) : courses.length > 0 ? (
                    <ul className="courses-list">
                        {subscriptions.map((sub, index) => (
                            <li key={sub.id} className="course-item">
                                <span className="course-title">{courses[index]?.title || "Неизвестный курс"}</span>
                                <span className="course-dates">
                                    {sub.start_date ? new Date(sub.start_date).toLocaleDateString() : "—"} -{" "}
                                    {sub.end_date ? new Date(sub.end_date).toLocaleDateString() : "—"}
                                </span>
                                <button className="subscription-btn" onClick={() => fetchSubscriptionDetails(sub.id, courses[index]?.title)}>
                                    Управление подпиской
                                </button>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p>Нет купленных курсов</p>
                )}
            </div>

            {isSubscriptionModalOpen && selectedSubscription && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <button className="modal-close" onClick={() => setSubscriptionModalOpen(false)}>✖</button>
                        <h3 className="modal-header">Управление подпиской</h3>

                        <p className="course-title">
                            <strong>Курс:</strong> {selectedCourseTitle || "Неизвестно"}
                        </p>

                        <div className="subscription-detail">
                            <span className="subscription-label">Дата начала:</span>
                            <span className="subscription-value">
                                {new Date(selectedSubscription.start_date).toLocaleDateString()}
                            </span>
                        </div>

                        <div className="subscription-detail">
                            <span className="subscription-label">Дата окончания:</span>
                            {isEditingDate ? (
                                <input
                                    type="date"
                                    value={endDate.split("T")[0]}
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                            ) : (
                                <span className="subscription-value">
                                    {new Date(endDate).toLocaleDateString()}
                                </span>
                            )}
                            <span className="edit-icon" onClick={() => setIsEditingDate(!isEditingDate)}>✏️</span>
                        </div>

                        <div className="subscription-detail">
                            <span className="subscription-label">Дополнительные опции:</span>
                            <span className="edit-icon" onClick={() => setIsEditingOptions(!isEditingOptions)}>✏️</span>

                            {isEditingOptions ? (
                                <select multiple value={selectedOptions} onChange={handleOptionToggle}>
                                    {courseOptions.map((option) => (
                                        <option key={option.id} value={option.id}>
                                            {option.description} ({option.price} руб.)
                                        </option>
                                    ))}
                                </select>
                            ) : (
                                <ul className="subscription-value">
                                    {selectedOptions.length === 0
                                        ? <p>Нет опций</p>
                                        : selectedOptions.map((optionId) => {
                                            const option = courseOptions.find(opt => opt.id === optionId);
                                            return <li key={optionId}>{option ? option.description : "Неизвестная опция"}</li>;
                                        })}
                                </ul>
                            )}
                        </div>

                        <button className="update-btn" onClick={handleSaveSubscription}>Сохранить</button>
                        <button className="remove-btn" onClick={handleRemoveSubscription}>Удалить подписку</button>
                    </div>
                </div>
            )}

        </div>
    );
};

export default AssignCourse;
